import React from 'react';
import { Receipt } from '../../../../shared/assets/AppIcons';
import ExpenseForm from '@/modules/accounting/components/expenses/ExpenseForm';
import {
  CreateFormCancelButton,
  CreateFormDialog,
  CreateFormSubmitButton,
} from '../../../../shared/components/CreateFormDialog';

export default function CreateExpenseDialog({
  open,
  onOpenChange,
  staff = [],
  staffUnavailable = false,
  suppliers = [],
  supplierUnavailable = false,
  formState,
}) {
  return (
    <CreateFormDialog
      busy={formState.isSubmitting}
      open={open}
      onOpenChange={onOpenChange}
      icon={Receipt}
      title="Nuova Spesa"
      className="accounting-form-dialog"
      footer={
        <>
          <CreateFormCancelButton onClick={formState.onCancel} disabled={formState.isSubmitting} />
          <CreateFormSubmitButton form="expense-form" saving={formState.isSubmitting}>
            Salva spesa
          </CreateFormSubmitButton>
        </>
      }
    >
      <ExpenseForm
        {...formState}
        staff={staff}
        staffUnavailable={staffUnavailable}
        suppliers={suppliers}
        supplierUnavailable={supplierUnavailable}
        renderActions={false}
        requireDescription
        enableCustomFields
      />
    </CreateFormDialog>
  );
}
